import { render, staticRenderFns } from "./StatisticsMethodology.vue?vue&type=template&id=709e5eeb&"
import script from "./StatisticsMethodology.vue?vue&type=script&lang=js&"
export * from "./StatisticsMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports